import React from 'react';
import _ from 'lodash';

import formatClassroomsPostData from './format_classrooms_post_data';
import GrowthDiagnosticFollowup from './growth_diagnostic_followup.tsx';
import Stage1 from './select_activities_container';
import ShareToStudents from './share_activity_pack/shareToStudents';
import Stage2 from './stage2/Stage2';
import UnitAssignmentFollowup from './unit_assignment_followup.tsx';

import parsedQueryParams from '../parsedQueryParams';
import {
  ACTIVITY_IDS_ARRAY,
  ASSIGNED_CLASSROOMS,
  CLASSROOMS,
  UNIT_ID,
  UNIT_NAME,
  UNIT_TEMPLATE_ID,
  UNIT_TEMPLATE_NAME,
  baselineUnitTemplateIdToGrowthDiagnostic
} from '../../../../Shared';
import { requestGet, requestPost, } from '../../../../../modules/request';

export default class CreateUnit extends React.Component {
  constructor(props) {
    super(props)

    let stage = 1
    let name = ''
    let assignSuccess = false
    let classrooms = []
    const pathArray = props.location.pathname.split('/')
    const path = pathArray[pathArray.length - 1]
    const previouslyStoredName = props.match.params.unitName || window.localStorage.getItem(UNIT_NAME) || window.localStorage.getItem(UNIT_TEMPLATE_NAME)
    const previouslyStoredClassrooms = window.localStorage.getItem(CLASSROOMS) ? JSON.parse(window.localStorage.getItem(CLASSROOMS)) : []
    if (parsedQueryParams().unit_template_id || parsedQueryParams().diagnostic_unit_template_id || path === 'select-classes') {
      stage = 2
      name = previouslyStoredName
      classrooms = previouslyStoredClassrooms
    } else if (['next', 'referral', 'add-students'].includes(path)) {
      stage = 3;
      name = previouslyStoredName
      assignSuccess = true
      classrooms = previouslyStoredClassrooms
    } else if (path === 'schedule-growth-diagnostic') {
      stage = 4;
      assignSuccess = true
    }

    this.state = {
      prohibitedUnitNames: [],
      newUnitId: null,
      stage,
      selectedActivities: [],
      name,
      classrooms,
      assignSuccess,
      assignedUnitTemplateId: this.unitTemplateId(),
      assignedClassrooms: window.localStorage.getItem(ASSIGNED_CLASSROOMS) ? JSON.parse(window.localStorage.getItem(ASSIGNED_CLASSROOMS)) : [],
      model: {
        dueDates: {},
        publishDates: {}
      },
    }
  }

  componentDidMount = () => {
    const { classrooms, stage, assignSuccess, } = this.state
    const { history, } = this.props

    if (assignSuccess && !window.localStorage.getItem(ASSIGNED_CLASSROOMS)) {
      history.replace('/assign')
      return
    }

    this.getProhibitedUnitNames();

    this.fetchClassrooms()

    if (stage === 1 && this.unitTemplateId()) {
      window.localStorage.removeItem(UNIT_TEMPLATE_ID)
      window.localStorage.removeItem(UNIT_TEMPLATE_NAME)
      window.localStorage.removeItem(UNIT_NAME)
      window.localStorage.removeItem(ACTIVITY_IDS_ARRAY)
      window.localStorage.removeItem(CLASSROOMS)
      window.localStorage.removeItem(ASSIGNED_CLASSROOMS)
    }

    if (stage === 2 || window.localStorage.getItem(ACTIVITY_IDS_ARRAY)) {
      this.getActivities()
    }
  }

  onCreateSuccess = (response) => {
    const { history, } = this.props
    const { classrooms, name, } = this.state
    const { id } = response;
    const assignedClassrooms = classrooms.filter(c => c.classroom.emptyClassroomSelected || c.students.find(s => s.isSelected))
    this.setState({ newUnitId: id, assignSuccess: true, assignedClassrooms, assignedUnitTemplateId: this.unitTemplateId(), }, () => {
      window.localStorage.setItem(UNIT_NAME, name)
      window.localStorage.setItem(UNIT_ID, id)
      window.localStorage.setItem(ASSIGNED_CLASSROOMS, JSON.stringify(assignedClassrooms))
      if (assignedClassrooms.every(c => c.classroom.emptyClassroomSelected)) {
        history.push('/assign/add-students')
      } else {
        history.push('/assign/referral')
      }
      this.setStage(3);
    });
  }

  getActivities = () => {
    const { match, } = this.props
    const { stage, } = this.state
    const privateFlag = [2, 3].includes(stage) ? "?flagset=private" : ''
    requestGet(`/activities/search${privateFlag}`, (body) => {
      const { activities, } = body
      const activityIdsArray = match.params.activityIdsArray || window.localStorage.getItem(ACTIVITY_IDS_ARRAY)
      if (!activityIdsArray) { return }

      const activityIdsArrayAsArray = activityIdsArray.split(',')
      const selectedActivities = activityIdsArrayAsArray.map(id => activities.find(act => String(act.id) === id)).filter(Boolean)
      this.setState({ activities: activities, selectedActivities: selectedActivities, })
    })
  }

  getClassrooms = () => {
    const { classrooms, } = this.state
    return classrooms
  }

  getId = () => {
    const { model, } = this.state
    return model.id;
  }

  getProhibitedUnitNames = () => {
    requestGet('/teachers/prohibited_unit_names', (data) => {
      this.setState({ prohibitedUnitNames: data.prohibitedUnitNames, });
    });
  }

  getSelectedActivities = () => {
    const { selectedActivities, } = this.state
    return selectedActivities
  }

  getStage = () => {
    const { stage, } = this.state
    return stage
  }

  getUnitName = () => {
    const { name, } = this.state
    return name
  }

  setStage = (stage) => {
    this.setState({ stage, });
  }

  areAnyStudentsSelected = () => {
    const classroomsWithSelectedStudents = this.getClassrooms().filter(c => {
      let includeClassroom;
      if (this.emptyClassroomSelected(c)) {
        includeClassroom = true;
      } else {
        const selectedStudents = c.students.filter(s => s.isSelected)
        includeClassroom = selectedStudents.length > 0;
      }
      return includeClassroom;
    })

    return (classroomsWithSelectedStudents.length > 0);
  }

  assignActivityDate = (activity, date, dateKey) => {
    const { model, } = this.state
    model[dateKey][activity.id] = date;
    this.setState({ model, });
  }

  clickContinue = () => {
    const { history, } = this.props
    history.push('/assign/select-classes')
    this.setStage(2);
    this.resetWindowPosition();
  }

  determineIfInputProvidedAndValid = () => {
    return (this.getSelectedActivities().length > 0);
  }

  determineStage1ErrorMessage = () => {
    if (!this.getSelectedActivities().length > 0) {
      return 'Please select activities';
    }
  }

  determineStage2ErrorMessage = () => {
    if (!this.areAnyStudentsSelected()) {
      return { students: 'Please select students', }
    } else if (!this.isUnitNameValid()) {
      return { name: 'Please provide a name for your activity pack.', }
    } else if (!this.isUnitNameUnique()) {
      return { name: "Each activity pack needs a unique name. You're already using that name for another activity pack. Please choose a different name.", }
    }
  }

  dueDate = (id) => {
    const { model, } = this.state
    if (model.dueDates && model.dueDates[id]) {
      return model.dueDates[id];
    }
  }

  publishDate = (id) => {
    const { model, } = this.state
    if (model.publishDates && model.publishDates[id]) {
      return model.publishDates[id];
    }
  }

  emptyClassroomSelected = (c) => {
    return c.classroom.emptyClassroomSelected === true
  }

  fetchClassrooms = () => {
    requestGet('/teachers/classrooms/retrieve_classrooms_i_teach_for_custom_assigning_activities', (body) => {
      window.localStorage.setItem(CLASSROOMS, JSON.stringify(body.classrooms_and_their_students))
      this.setState({ classrooms: body.classrooms_and_their_students }, this.preselectClassroomFromQueryParams)
    })
  }

  // one-shot so refetches mid-flow (e.g. after a classroom import) can't re-select a classroom the teacher deselected
  preselectClassroomFromQueryParams = () => {
    const { stage, } = this.state
    const classroomId = parsedQueryParams().classroom
    if (stage !== 2 || !classroomId || this.appliedClassroomPreselection) { return }

    this.appliedClassroomPreselection = true
    this.toggleClassroomSelection({ id: Number(classroomId) }, true)
  }

  finish = () => {
    const data = this.formatCreateRequestData()
    this.setState({ createErrorType: null })
    requestPost('/teachers/units', data, (body) => {
      this.onCreateSuccess(body)
    }, (body) => {
      this.setState({ createErrorType: body?.error_type || 'generic' })
    })
  }

  clearCreateError = () => {
    this.setState({ createErrorType: null })
  }

  formatCreateRequestData = () => {
    let classroomPostData = this.getClassrooms().filter((c) => {
      let includeClassroom
      let selectedStudents;
      if (this.emptyClassroomSelected(c)) {
        includeClassroom = true;
      } else {
        selectedStudents = c.students.filter(s => s.isSelected)
        includeClassroom = selectedStudents.length > 0;
      }
      return includeClassroom;
    });

    classroomPostData = formatClassroomsPostData(classroomPostData)

    const selectedActivities = this.getSelectedActivities();

    const activityPostData = selectedActivities.map((sa) => {
      return {
        id: sa.id,
        due_date: this.dueDate(sa.id),
        publish_date: this.publishDate(sa.id)
      }
    })

    const unitObject = {
      unit: {
        id: this.getId(),
        name: this.getUnitName(),
        classrooms: classroomPostData,
        activities: activityPostData,
        unit_template_id: this.unitTemplateId()
      }
    };
    return unitObject;
  }

  isUnitNameUnique = () => {
    const { prohibitedUnitNames, } = this.state
    const unit = this.getUnitName();
    return !prohibitedUnitNames.includes(unit.toLowerCase());
  }

  isUnitNameValid = () => this.getUnitName() && this.getUnitName().length

  resetWindowPosition = () => {
    window.scrollTo(500, 0);
  }

  stage1SpecificComponents = () => {
    const { activities, } = this.state
    const { showLessonsBanner, showEvidenceBanner, flagset, } = this.props
    return (
      <Stage1
        activities={activities}
        clickContinue={this.clickContinue}
        determineIfInputProvidedAndValid={this.determineIfInputProvidedAndValid}
        errorMessage={this.determineStage1ErrorMessage()}
        flagset={flagset}
        selectedActivities={this.getSelectedActivities()}
        setSelectedActivities={this.setSelectedActivities}
        showEvidenceBanner={showEvidenceBanner}
        showLessonsBanner={showLessonsBanner}
        toggleActivitySelection={this.toggleActivitySelection}
      />
    );
  }

  restrictedActivityBeingAssigned = () => {
    const { assignedPreTests, } = this.props
    const { selectedActivities, } = this.state

    const restrictedActivityIds = assignedPreTests.map(pretest => pretest.post_test_id)
    return selectedActivities && selectedActivities.find(act => restrictedActivityIds.includes(act.id))
  }

  lockedClassroomIds = () => {
    const { assignedPreTests, } = this.props
    const { classrooms, } = this.state
    let lockedClassroomIds = []

    const restrictedActivity = this.restrictedActivityBeingAssigned()

    if (restrictedActivity) {
      const relevantPretest = assignedPreTests.find(pretest => pretest.post_test_id === restrictedActivity.id)
      lockedClassroomIds = classrooms.filter(c => !relevantPretest.assigned_classroom_ids.includes(c.classroom.id)).map(c => c.classroom.id)
    }

    return lockedClassroomIds
  }

  notYetCompletedPreTestStudentNames = () => {
    const { assignedPreTests, } = this.props
    const { classrooms, } = this.state

    const restrictedActivity = this.restrictedActivityBeingAssigned()
    if (!restrictedActivity) { return [] }

    const relevantPretest = assignedPreTests.find(pretest => pretest.post_test_id === restrictedActivity.id)
    const studentsBeingAssignedWhoDidNotCompletePreTest = []
    classrooms.forEach(c => {
      const studentsBeingAssigned = c.students.filter(s => s.isSelected)
      const relevantPreTestClassroom = relevantPretest.all_classrooms.find(ac => ac.id === c.classroom.id)
      studentsBeingAssigned.forEach(s => {
        if (!relevantPreTestClassroom.completed_pre_test_student_ids.includes(s.id)) {
          studentsBeingAssignedWhoDidNotCompletePreTest.push(s.name)
        }
      })
    })
    return studentsBeingAssignedWhoDidNotCompletePreTest
  }

  // Warns when a teacher tries to assign a pack containing a baseline (pre) or growth (post)
  // diagnostic to a class that already has an existing pack containing that same diagnostic.
  // Returns the data the override warning modal needs, or null when there is no duplicate.
  reassignDiagnosticWarning = () => {
    const { assignedPreTests, } = this.props
    const { selectedActivities, classrooms, } = this.state

    const preTestActivityIds = assignedPreTests.map(pretest => pretest.id)
    const postTestActivityIds = assignedPreTests.map(pretest => pretest.post_test_id)
    const preTestBeingAssigned = selectedActivities && selectedActivities.find(act => preTestActivityIds.includes(act.id))
    const postTestBeingAssigned = selectedActivities && selectedActivities.find(act => postTestActivityIds.includes(act.id))
    const diagnosticBeingAssigned = preTestBeingAssigned || postTestBeingAssigned

    if (!diagnosticBeingAssigned) { return null }

    const relevantPretest = preTestBeingAssigned
      ? assignedPreTests.find(pretest => pretest.id === preTestBeingAssigned.id)
      : assignedPreTests.find(pretest => pretest.post_test_id === postTestBeingAssigned.id)
    const unitIdKey = preTestBeingAssigned ? 'pre_test_unit_id' : 'post_test_unit_id'
    const assignedStudentIdKey = preTestBeingAssigned ? 'assigned_pre_test_student_ids' : 'assigned_post_test_student_ids'

    const selectedClassroomIds = classrooms
      .filter(c => c.students.find(s => s.isSelected) || c.classroom.emptyClassroomSelected)
      .map(c => c.classroom.id)

    const classroomsWithExistingPack = relevantPretest.all_classrooms
      .filter(ac => selectedClassroomIds.includes(ac.id) && ac[unitIdKey])

    if (!classroomsWithExistingPack.length) { return null }

    // Count every student already assigned the existing pack in the selected classes -- NOT just
    // the students the teacher is now (re)assigning. A teacher can select only new classmates, but
    // Quill still warns them about the students whose diagnostic data a duplicate pack overwrites.
    const assignedStudentNamesById = new Map()
    classroomsWithExistingPack.forEach(ac => {
      const classroomState = classrooms.find(c => c.classroom.id === ac.id)
      ac[assignedStudentIdKey].forEach(id => {
        const student = classroomState && classroomState.students.find(s => s.id === id)
        if (student) { assignedStudentNamesById.set(id, student.name) }
      })
    })
    const assignedStudentNames = [...assignedStudentNamesById.values()]

    // One entry per distinct existing pack, labeled by classroom, so a teacher assigning to
    // multiple classes at once can resolve every conflicting pack -- not just the first.
    const seenUnitIds = new Set()
    const existingPacks = classroomsWithExistingPack.reduce((packs, ac) => {
      const unitId = ac[unitIdKey]
      if (seenUnitIds.has(unitId)) { return packs }
      seenUnitIds.add(unitId)
      const classroomState = classrooms.find(c => c.classroom.id === ac.id)
      packs.push({ unitId, classroomName: classroomState && classroomState.classroom.name })
      return packs
    }, [])

    return {
      diagnosticName: diagnosticBeingAssigned.name,
      assignedStudentNames,
      existingPacks,
    }
  }

  stage2SpecificComponents = () => {
    const { model, createErrorType, } = this.state
    const { cleverLink, googleLink, user, showGradeLevelWarning, } = this.props

    const restrictedActivity = this.restrictedActivityBeingAssigned()

    return (
      <Stage2
        areAnyStudentsSelected={this.areAnyStudentsSelected()}
        assignActivityDate={this.assignActivityDate}
        classrooms={this.getClassrooms()}
        clearCreateError={this.clearCreateError}
        cleverLink={cleverLink}
        createErrorType={createErrorType}
        data={this.assignSuccess}
        dueDates={model.dueDates}
        errorMessage={this.determineStage2ErrorMessage()}
        fetchClassrooms={this.fetchClassrooms}
        finish={this.finish}
        googleLink={googleLink}
        isFromDiagnosticPath={!!parsedQueryParams().diagnostic_unit_template_id}
        lockedClassroomIds={this.lockedClassroomIds()}
        notYetCompletedPreTestStudentNames={this.notYetCompletedPreTestStudentNames()}
        publishDates={model.publishDates}
        reassignDiagnosticWarning={this.reassignDiagnosticWarning()}
        restrictedActivity={restrictedActivity}
        selectedActivities={this.getSelectedActivities()}
        showGradeLevelWarning={showGradeLevelWarning}
        toggleActivitySelection={this.toggleActivitySelection}
        toggleClassroomSelection={this.toggleClassroomSelection}
        toggleStudentSelection={this.toggleStudentSelection}
        unitName={this.getUnitName()}
        unitTemplateId={this.unitTemplateId()}
        unitTemplateName={this.unitTemplateName()}
        updateUnitName={this.updateUnitName}
        user={user}
      />
    )
  }

  moveToStage4 = () => {
    const { history, } = this.props
    if (this.growthDiagnostic()) {
      history.push('/assign/schedule-growth-diagnostic')
      return
    }
    this.setStage(4);
  }

  stage3specificComponents = () => {
    const { assignSuccess, name, selectedActivities } = this.state;
    if (assignSuccess) {
      const activityPackData = {
        name: name,
        activityCount: selectedActivities && selectedActivities.length,
        activities: selectedActivities
      }
      return(
        <ShareToStudents
          activityPackData={activityPackData}
          moveToStage4={this.moveToStage4}
        />
      );
    }
  }

  growthDiagnostic = () => {
    const { assignedUnitTemplateId, } = this.state
    return baselineUnitTemplateIdToGrowthDiagnostic[Number(assignedUnitTemplateId)] || null
  }

  stage4specificComponents = () => {
    const { referralCode, location, history, } = this.props
    const { classrooms, selectedActivities, name, assignSuccess, newUnitId, assignedClassrooms, assignedUnitTemplateId, activities, } = this.state
    const growthDiagnostic = this.growthDiagnostic()
    if (assignSuccess && growthDiagnostic) {
      return (
        <GrowthDiagnosticFollowup
          activities={activities}
          assignedClassrooms={assignedClassrooms}
          assignedUnitTemplateId={assignedUnitTemplateId}
          growthDiagnostic={growthDiagnostic}
        />
      );
    }

    if (assignSuccess) {
      return (
        <UnitAssignmentFollowup
          classrooms={classrooms}
          history={history}
          location={location}
          referralCode={referralCode}
          selectedActivities={selectedActivities}
          unitName={name}
        />
      );
    }

    if (_.map(selectedActivities, activity => { return activity.activity_classification.id }).includes(6)) {
      // There is a lesson here, so we should send the teacher to the Lessons page.
      window.location.href = `/teachers/classrooms/activity_planner/lessons#${newUnitId}`;
    } else {
      window.location.href = `/teachers/classrooms/activity_planner#${newUnitId}`;
    }
  }

  toggleActivitySelection = (activity) => {
    const { selectedActivities, } = this.state
    activity.selected = !activity.selected
    const indexOfActivity = selectedActivities.findIndex(act => act.id === activity.id);
    const newActivityArray = selectedActivities.slice();
    if (indexOfActivity === -1) {
      newActivityArray.push(activity);
    } else {
      newActivityArray.splice(indexOfActivity, 1);
    }
    this.setSelectedActivities(newActivityArray)
  }

  setSelectedActivities = (newActivityArray) => {
    const newActivityArrayIds = newActivityArray.map(a => a.id).join(',')
    this.setState({ selectedActivities: newActivityArray, }, () => {
      window.localStorage.setItem(ACTIVITY_IDS_ARRAY, newActivityArrayIds)
    })
  }

  toggleClassroomSelection = (classroom = null, select = null) => {
    const classrooms = this.getClassrooms();
    const selectHasValue = select === true || select === false
    if (!classrooms) {
      return;
    }

    const lockedClassroomIds = this.lockedClassroomIds()
    const updated = classrooms.map((c) => {
      if (lockedClassroomIds.includes(c.classroom.id)) { return c }
      const classroomGettingUpdated = c
      if (!classroom || classroomGettingUpdated.classroom.id === classroom.id) {
        const { students, } = classroomGettingUpdated
        if (!students.length) {
          classroomGettingUpdated.classroom.emptyClassroomSelected = selectHasValue ? select : this.toggleEmptyClassroomSelected(c);
        } else {
          const selected = students.filter(s => s.isSelected)
          const updatedStudents = students.map((s) => {
            const student = s
            student.isSelected = selectHasValue ? select : !selected.length
            return student;
          })
          classroomGettingUpdated.students = updatedStudents;
        }
      }
      return c;
    })
    this.setState({ classrooms: updated, }, () => window.localStorage.setItem(CLASSROOMS, JSON.stringify(updated)));
  }

  toggleEmptyClassroomSelected = (c) => {
    return !(this.emptyClassroomSelected(c));
  }

  toggleStudentSelection = (studentIds, classroomId) => {
    const allClassrooms = this.getClassrooms()
    const updated = allClassrooms.map((c) => {
      const changedClassroom = c
      if (changedClassroom.classroom.id === classroomId) {
        const updateStudents = changedClassroom.students.map((s) => {
          const student = s
          student.isSelected = studentIds.includes(student.id)
          return student;
        });
        changedClassroom.students = updateStudents;
      }
      return changedClassroom;
    })
    this.setState({ classrooms: updated, }, () => window.localStorage.setItem(CLASSROOMS, JSON.stringify(updated)));
  }

  unitTemplateId = () => parsedQueryParams().unit_template_id || parsedQueryParams().diagnostic_unit_template_id || window.localStorage.getItem(UNIT_TEMPLATE_ID)

  unitTemplateName = () => {
    const { match, } = this.props
    match.params.unitName || window.localStorage.getItem(UNIT_TEMPLATE_NAME)
  }

  updateUnitName = (name) => {
    this.isUnitNameValid();
    this.setState({ name, });
  }

  render = () => {
    const { stage } = this.state;
    let stageSpecificComponents;

    if (stage === 1) {
      stageSpecificComponents = this.stage1SpecificComponents();
    } else if (stage === 2) {
      stageSpecificComponents = this.stage2SpecificComponents();
    } else if (stage === 3) {
      stageSpecificComponents = this.stage3specificComponents();
    } else if (stage === 4) {
      stageSpecificComponents = this.stage4specificComponents();
    }
    return (
      <span>
        <div id="activity-planner">
          {stageSpecificComponents}
        </div>
      </span>

    );
  }
}
